import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullDeal from "./fragments/fullDeal"
import dealBirthdayBox from "./fragments/dealBirthdayBox"

const query = gql`
  query DealByUrlSlug($urlSlug: String, $isRewards: Boolean) {
    dealBySlug(urlSlug: $urlSlug, isRewards: $isRewards) {
      ...fullDeal
      ...dealBirthdayBox
    }
  }
  ${fullDeal}
  ${dealBirthdayBox}
`

export const dealBySlugQueryKey = getQueryNames(query)[0]

export default query
